module.exports = __webpack_public_path__ + "static/img/orderempty@2x.214cb4e9.png";